import { render, staticRenderFns } from "./PosWarehouseProductList.vue?vue&type=template&id=70fb2d85&scoped=true&"
import script from "./PosWarehouseProductList.vue?vue&type=script&lang=js&"
export * from "./PosWarehouseProductList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70fb2d85",
  null
  
)

export default component.exports